import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { EnquiryForm } from "./EnquiryForm";

export const EnquiryDialog = ({ trigger, defaultTreatment = "", defaultType = "consultation" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="rounded-none border-border sm:max-w-lg" data-testid="enquiry-dialog">
        <DialogHeader>
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary">DK Aesthetics</p>
          <DialogTitle className="font-display text-3xl font-light tracking-tight">
            {defaultType === "consultation" ? "Book your free 15-minute consultation" : "Enquire about an appointment"}
          </DialogTitle>
        </DialogHeader>
        <EnquiryForm
          defaultTreatment={defaultTreatment}
          defaultType={defaultType}
          onSuccess={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
